export class HrmsEmployeeRequest{
    employeeId: number;
    
    
    constructor( employeeId: number,
        ){
            this.employeeId= employeeId;
        }
    
    }